module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"manager":"Manager","accountSetting":"Setting","toggleGroup":"Group","logOut":"Logout","groupManage":"Group Manage"},"zh":{"manager":"管理员","accountSetting":"账号设置","toggleGroup":"切换组织","logOut":"退出登录","groupManage":"组织管理"}}')
  delete Component.options._Ctor
}
